import { createAction, props } from '@ngrx/store';
import { TreeNode } from 'primeng/api';

export const toggleNode = createAction('TeamsLocationToggleNode', props<{ key: string; expanded: boolean }>());
export const selectNode = createAction('TeamsLocationSelectNode', props<{ key: string }>());
export const loadTeamsSuccess = createAction('TeamsLocationLoadSuccess', props<{ categories: TreeNode[] }>());
export const refreshTree = createAction('TeamsLocationRefresh');
